import { getExtensionFromMimeType } from './getExtensionFromMimeType'
import { base64ToByteArray } from './base64TtoByteArray'
import { formatDateToCustomFormat } from './getIsoStringDate'

export function formatCreateA3DocJson({
    token,
    content,
    extension,
    containersIds,
    isAppDocument,
    companyNif,
    companyName,
    innuvaCompanyCode,
    docName
}) {
    let plantillaModificada = {
        "Token": token || null,
        "Content": base64ToByteArray(content) || [],
        "Extension": getExtensionFromMimeType(extension) || "",
        "ContainersIds": containersIds.map(item => item.id) || [],
        "isAppDocument": isAppDocument !== undefined ? isAppDocument : false,
        ...(isAppDocument && { "ApplicationGUIDs": ['21DC83DB-B187-4993-8C3E-0B4DF8B15632'] }),
        "DocumentAttributes": [
            {
                "Name": "Cliente",
                "Value": companyNif,
                "ID": "1",
                "Description": companyName
            },
            {
                "Name": "Título",
                "Value": docName,
                "ID": "3",
                "Description": ""
            },
            {
                "Name": "Fecha Documento",
                "Value": `${formatDateToCustomFormat(new Date())}`,
                "ID": "4",
                "Description": ""
            },
            {
                "Name": "Observaciones",
                "Value": "",
                "ID": "7",
                "Description": ""
            },
            {
                "Name": "Visibilidad",
                "Value": "1",
                "ID": "10",
                "Description": "Visible"
            },
            {
                "Name": "Empresa",
                "Value": `${innuvaCompanyCode}`,
                "ID": "800",
                "Description": companyName
            }
        ],
        "DocumentAttributeValues": [
            {
                "ID": "1",
                "DetailsMainField": "Identificador",
                "Items": [
                    {
                        "Name": "Identificador",
                        "Value": companyNif
                    },
                    {
                        "Name": "Nombre",
                        "Value": companyName
                    }
                ]
            },

            {
                "ID": "800",
                "DetailsMainField": "Código",
                "Items": [
                    {
                        "Name": "Código",
                        "Value": `${innuvaCompanyCode}`
                    },
                    {
                        "Name": "Nombre",
                        "Value": companyName
                    },
                    {
                        "Name": "NIF",
                        "Value": companyNif
                    },
                    {
                        "Name": "Cliente",
                        "Value": companyName
                    },
                    {
                        "Name": "FK",
                        "Value": companyNif
                    }
                ]
            }
        ]
    };

    return plantillaModificada;
}
